import { render, staticRenderFns } from "./05.3-FloorsDiagram.vue?vue&type=template&id=5a5edf54&scoped=true&"
import script from "./05.3-FloorsDiagram.vue?vue&type=script&lang=js&"
export * from "./05.3-FloorsDiagram.vue?vue&type=script&lang=js&"
import style0 from "./05.3-FloorsDiagram.vue?vue&type=style&index=0&id=5a5edf54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5edf54",
  null
  
)

/* custom blocks */
import block0 from "./05.3-FloorsDiagram.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports